import React from 'react';

import ExpertRightSettingsMainSubTitleComponent from '../../../../expertDashboardModule/expertSettingsComponent/components/expertRightSettingsComponent/components/expertRightSettingsMainSubTitleComponent/expertRightSettingsMainSubTitleComponent';
import RadioButtonComponent from '../radioButtonComponent/radioButtonComponent';
import SeparatorComponent from '../../separatorComponent/separatorComponent';
import SubTitleComponentV2 from '../subTitleComponentV2/subTitleComponentV2';
import UpgradeComponent from '../upgradeComponent/upgradeComponent';

import './multiRadioButtonComponent.css';

const MultiRadioButtonComponent = ({
  id = '',
  isDisabled = false,
  billingPlanFeature = null,
  options = [],
  pillType = null,
  selectedRadioBtnId = null,
  subTitleTxt = null,
  titleTxt = null,
  onRadioBtnClicked = () => {},
}) => {
  const handleRadioBtnClicked = (id, radioBtnId) => {
    if (!isDisabled && selectedRadioBtnId !== radioBtnId) {
      onRadioBtnClicked(id, radioBtnId);
    }
  };

  return (
    <div className="et-v2-multi-radio-button-container">
      <UpgradeComponent billingPlanFeature={billingPlanFeature} />

      {titleTxt && (
        <ExpertRightSettingsMainSubTitleComponent
          pillType={pillType}
          subTitleTxt={titleTxt}
        />
      )}
      {subTitleTxt && (
        <>
          <SeparatorComponent isSmall />
          <SubTitleComponentV2 subTitleTxt={subTitleTxt} />
        </>
      )}
      <SeparatorComponent isSmall />
      <div className="et-v2-mrb-radio-btns-wrap">
        {options.map(
          ({
            id: radioBtnId,
            titleTxt,
            toolTipPosition,
            toolTipTxt,
            subTitleTxt,
          }) => {
            return (
              <RadioButtonComponent
                key={radioBtnId}
                isDisabled={isDisabled}
                isSelected={radioBtnId === selectedRadioBtnId}
                billingPlanFeature={billingPlanFeature}
                titleTxt={titleTxt}
                toolTipPosition={toolTipPosition}
                toolTipTxt={toolTipTxt}
                subTitleTxt={subTitleTxt}
                onClick={() => {
                  handleRadioBtnClicked(id, radioBtnId);
                }}
              />
            );
          },
        )}
      </div>
    </div>
  );
};

export default MultiRadioButtonComponent;
